import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "../app/appHooks";
import { RFIDPolicy, SettingListKeys } from "../../helpers/constants";
import { Grid, List } from "@material-ui/core";
import { SettingsListItem } from "./common/SettingsListItem";
import { useTranslation } from "react-i18next";
import { setRFIDConfig } from "./settingsSlice";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      position: "relative",
      height: "100%",
      width: "50%",
      borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    },
    listItem: {
      background: "#FFF",
      marginTop: theme.spacing(3),
    },
    optionsContainer: {
      width: "100%",
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(3),
    },
    column: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    primaryText: {
      fontWeight: "bold",
    },
    alignRight: {
      textAlign: "right",
    },
  })
);

const unitWithoutResidentOptions = {
  add_resident: "add_resident",
};
export const unitWithResidentOptions = {
  resident_settings: "resident_settings",
  resident_contacts: "resident_contacts",
  emergency_contacts: "emergency_contacts",
};
const unitWithInstallerOptions = {
  resident_settings: "resident_settings",
};

export const unitSettings = {
  pause_stackcare: "pause_stackcare",
  unit_settings: "unit_settings",
};

export const unitOptions = {
  ...unitWithoutResidentOptions,
  ...unitWithResidentOptions,
  ...unitSettings,
  ...unitWithInstallerOptions,
};

export const RFIDUnitsList = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /* Selectors */
  const selectedOption = useAppSelector(
    (state) => state.settingsState.selectedOption
  );

  const selectedRFIDConfig = useAppSelector(
    (state) => state.settingsState.selectedRFIDConfig
  );

  const community = useAppSelector(
    (state) => state.headerState.selectedCommunity
  );
  const rfidPolicy = community?.rfid_policy || RFIDPolicy.DISABLED;

  const classes = useStyles();

  const handleOpenScanEnforcement = () => {
    dispatch(setRFIDConfig());
  };

  const rfidPolicyKey = (policy?: string | null) => {
    switch ((policy || RFIDPolicy.DISABLED).toLowerCase()) {
      case RFIDPolicy.BLOCK:
        return "rfid_policy_block_title";
      case RFIDPolicy.WARN:
        return "rfid_policy_warn_title";
      default:
        return "rfid_policy_disabled_title";
    }
  };

  return (
    <>
      {selectedOption === SettingListKeys.rfid_tags && (
        <div className={classes.mainContainer}>
          <List className={classes.optionsContainer}>
            <SettingsListItem
              button
              disableGutters
              onClick={handleOpenScanEnforcement}
              selected={selectedRFIDConfig}
              className={classes.listItem}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={6} className={classes.column}>
                  <div className={classes.primaryText}>
                    {t("rfid_policy_title")}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={6}
                  className={clsx(classes.column, classes.alignRight)}
                >
                  <div>{t(rfidPolicyKey(rfidPolicy))}</div>
                </Grid>
              </Grid>
            </SettingsListItem>
          </List>
        </div>
      )}
    </>
  );
};
